import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import TableTimeStamps from '../../../../../components/utils/TableTimeStamps';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import {
  GetCompanyVectorPrefsSummaryBIZcoreTD
} from '../../../../../redux/actions/business/core/tradeDefencesActions';

import CompanyVectorPrefModal from './CompanyVectorPrefModal';
import CompanyVectorPrefsDetailModal from './CompanyVectorPrefsDetailModal';

import global from "../../../../../global.scss";

const CompanyVectorPrefPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.tradeDefence"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addModalTitle, setAddModalTitle] = useState("");
  const [update, setUpdate] = useState(null);

  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  const [uniqueCompanies, setUniqueCompanies] = useState([]);

  useEffect(() => {
    handleGetCompanyVectorPrefs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      setUniqueCompanies(state.companyVectorPrefsSummaryList?.records || []);
    } catch (err) {}
  }, [state]);

  async function handleGetCompanyVectorPrefs(customLoading) {
    await dispatch(GetCompanyVectorPrefsSummaryBIZcoreTD(true, customLoading ? customLoading : setLoading));
  }

  const filteredCompanies = search
    ? uniqueCompanies.filter(c =>
        c.company_id.toLowerCase().includes(search.toLowerCase()) ||
        (c.company_name || '').toLowerCase().includes(search.toLowerCase())
      )
    : uniqueCompanies;

  return (
    <Box>

      <CompanyVectorPrefModal
        open={addModalOpen}
        setOpen={setAddModalOpen}
        title={addModalTitle}
        update={update}
        handleGet={handleGetCompanyVectorPrefs}
      />

      <CompanyVectorPrefsDetailModal
        open={detailModalOpen}
        setOpen={setDetailModalOpen}
        companyId={selectedCompanyId}
        handleGetMain={handleGetCompanyVectorPrefs}
      />

      <TopBar
        title={"Company Vector Preferences"}
        search={search}
        onSearchChange={(e) => setSearch(e.target.value)}
        button1Text={"Add preference"}
        button1OnClick={() => {
          setUpdate({ defaultMode: 1 });
          setAddModalTitle("Add company vector preference");
          setAddModalOpen(true);
        }}
      />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          filteredCompanies.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No company vector preferences found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                <TableCell>Company</TableCell>
                <TableCell>Vectors assigned</TableCell>
                <TableCell>Last updated</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                filteredCompanies.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography variant='body2'>{row.company_name || <NA />}</Typography>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.company_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={row.count}
                        color="info"
                      />
                    </TableCell>
                    <TableCell>
                      <TableTimeStamps updatedAt={row.updated_at} />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setSelectedCompanyId(row.company_id);
                          setDetailModalOpen(true);
                        }}
                      >
                        <VisibilityOutlinedIcon sx={{ color: global['secondary_light'] }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
      }

    </Box>
  );
};

export default CompanyVectorPrefPage;
